import apiClient from './apiClient';

export type BookingStatus = 'SCHEDULED' | 'CONFIRMED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';

export interface BookingResponse {
    id: string;
    salonId: string;
    employeeId: string;
    serviceId: string;
    serviceName: string;
    clientName: string;
    clientPhone: string;
    startTime: string;
    endTime: string;
    status: BookingStatus;
    notes?: string; // Added notes field to BookingResponse
}

export interface BookingCreateRequest {
    salonId: string;
    employeeId: string;
    serviceId: string;
    clientId?: string; // New: reference to Client entity
    clientName?: string; // Legacy: for backward compatibility
    clientPhone?: string; // Legacy: for backward compatibility
    startTime: string;
}

// Define BookingUpdateRequest based on BookingCreateRequest and BookingResponse fields that can be updated
export interface BookingUpdateRequest {
    salonId?: string;
    employeeId?: string;
    serviceId?: string;
    clientId?: string;
    clientName?: string;
    clientPhone?: string;
    startTime?: string;
    endTime?: string;
    status?: BookingStatus;
    notes?: string;
}

export const bookingApi = {
    getSalonAppointments: async (salonId: string, date: string, endDate?: string): Promise<BookingResponse[]> => {
        const response = await apiClient.get<BookingResponse[]>(`/bookings/salon/${salonId}`, {
            params: { date, endDate },
        });
        return response.data;
    },

    createAppointment: async (data: BookingCreateRequest): Promise<BookingResponse> => {
        const response = await apiClient.post<BookingResponse>('/bookings', data);
        return response.data;
    },

    updateAppointment: async (id: string, data: BookingUpdateRequest): Promise<BookingResponse> => {
        const response = await apiClient.put<BookingResponse>(`/bookings/${id}`, data);
        return response.data;
    },

    getAlerts: async (salonId: string): Promise<BookingAlertsResponse> => {
        const response = await apiClient.get<BookingAlertsResponse>(`/bookings/salon/${salonId}/alerts`);
        return response.data;
    },
};

export interface BookingAlertItem {
    appointmentId: string;
    type: string;
    message: string;
    employeeId: string;
    employeeName?: string;
    startTime: string;
}

export interface BookingAlertsResponse {
    overdueCount: number;
    upcomingCount: number;
    inProgressCount: number;
    alerts: BookingAlertItem[];
}

